import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Actions
import { setPage, togglePostModal } from '../../actions/navActions';

// Components - imported
import { Avatar, Button } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';
import GoogleBtn from '../common/GoogleBtn';
import SidebarProfileWidget from './SidebarProfileWidget';

// Icons -imported
import TwitterIcon from '@material-ui/icons/Twitter';
import HomeIcon from '@material-ui/icons/Home';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import StorefrontIcon from '@material-ui/icons/Storefront';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import MailIcon from '@material-ui/icons/Mail';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import PersonIcon from '@material-ui/icons/Person';
import PostAddIcon from '@material-ui/icons/PostAdd';
import AddIcon from '@material-ui/icons/Add';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import FastfoodOutlinedIcon from '@material-ui/icons/FastfoodOutlined';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import PeopleIcon from '@material-ui/icons/People';

import SidebarOption from './SidebarOption';

import full_buysellapp_logo from '../../utils/imgs/full_buysellapp_logo.png';
import buysellapp_logo from '../../utils/imgs/buysellapp_logo.png';

const Sidebar = ({
    setPage,
    togglePostModal,
    auth: { 
        user, 
        modalUser,
        isAuthenticated, 
        loading 
    }, 
    nav: { 
        page,
        website,
        website_loading
    },
    isMobile,
    isTablet
}) => {

    // State to determine highlighted sidebar option
    const [navHighlight, setNavHighlight] = useState(null);

    // Toggle Dropdwon
    const [profileDropdown, setProfileDropdown] = useState(false);

    // --- Set the navigation highlight based on the current page
    useEffect(() => {
        if(page === 'home') {
            setNavHighlight('home');
        }
        if(page === 'search') {
            setNavHighlight('search');
        }
        if(page === 'groups') {
            setNavHighlight('groups');
        }
        if(page === 'notifications') {
            setNavHighlight('settings');
        }

        if(page === 'messages') {
            setNavHighlight('messages');
        }

        if(page === 'saved') {
            setNavHighlight('settings');
        }

        if(page === 'profile') {
            setNavHighlight('profile');
        }

        if(page === 'settings') {
            setNavHighlight('settings');
        }

        // - Marketplace ---
        
        if(page === 'marketplace' || page === 'grocery landing' || page === 'product detail' || page === 'cart' || page === 'checkout' || page === 'collection') {
            setNavHighlight('grocery');
        }

    }, [page]);

    // Handle navigation to a specific page
    const todo = (page) => {
        setNavHighlight(page);
        setPage(page);
    }

    // Get User info
    let username = null;

    // Check if the user is logged in and set the username
    if(user) {
        username = user.username;
    }

    let isMyProfile = false;

    // Check if the current highlighted navigation is 'profile'
    if(navHighlight === "profile") {
        if(user && modalUser && user._id !== modalUser._id) {
            isMyProfile = false;
        } else {
            isMyProfile = true;
        }
    }

    let user_name;

    if(!loading && isAuthenticated) {
        user_name = `${user.first_name} ${user.last_name && user.last_name}`
    }

    let app_logo = full_buysellapp_logo;

    if(isTablet) {
        app_logo = buysellapp_logo;
    }

    // -- Custom URL Logic --

    if(website?.website_logo) {
        app_logo = website?.website_logo;
    }

    // -- END: Custom URL Logic --

    // --- ImageKit (img optimization service) ---
    
    let optimized_profile_img_path;

    if(user && user.img) {
   
        // Replace the firebase URL with ImageKit.io URL-endpoint
        optimized_profile_img_path = user.img.replace("https://firebasestorage.googleapis.com","https://ik.imagekit.io/pba3w2st28/");
    }

    // --- END: ImageKit (img optimization service) ---

    return (
        <div className="sidebar" style={{display:'flex', position:'relative', flexDirection: 'column'}}>
            {/* Custom URL Logic */}
            {!website_loading ? (
                <div onClick={() => window.location = '/'} style={{cursor: 'pointer'}}>
                    <img className={`sidebar__twitterIcon small_logo`} src={app_logo} alt="logo" />
                </div>
            ) : (
                // Placeholder
                <div className='sidebar__twitterIcon small_logo'></div>
            )}
           

            {/* --- Sidebar options */}

            <SidebarOption active={navHighlight === "home"} Icon={navHighlight === "home" ? HomeIcon : HomeOutlinedIcon} text="Home" link="/home" />
            <SidebarOption active={navHighlight === "search"} Icon={SearchOutlinedIcon} text="Search" link="/search" />
            {/* <SidebarOption active={navHighlight === "notifications"} Icon={navHighlight === "notifications" ? NotificationsIcon : NotificationsNoneIcon} text="Notifications" link="/notifications" /> */}
            <SidebarOption active={navHighlight === "messages"} Icon={navHighlight === "messages" ? MailIcon : MailOutlineIcon} text="Messages" link="/messages" />
            {(!website_loading && !website) && <SidebarOption active={navHighlight === "groups"} Icon={navHighlight === "groups" ? PeopleIcon : PeopleOutlineIcon} text="Groups" link="/groups" />}
            {isAuthenticated && (<SidebarOption active={navHighlight === "profile"} Icon={navHighlight === "profile" ? PersonIcon : PersonOutlineIcon} text="Profile" link="/profile" />)}
            <SidebarOption active={navHighlight === "settings"} Icon={MoreHorizIcon} text="More" link="/settings" />

            {/* If the user is authenticated, show "More" as the text, otherwise show "Settings" */}
            {/* {!isAuthenticated && (
                <SidebarOption active={navHighlight === "settings"} Icon={!loading && isAuthenticated ? MoreHorizIcon : SettingsOutlinedIcon} text={!loading && isAuthenticated ? "More" : "Settings"} link="/settings" />
            )} */}

            {/* {!isAuthenticated && ( <SidebarOption active={navHighlight === "howitworks"} Icon={DeviceUnknownOutlinedIcon} text="How It Works" link="/howitworks" /> )} */}

            {/* Conditional rendering for create post button */}

            {!loading && (
                <Fragment>
                    {!isAuthenticated ? (
                        <Fragment>
                            <hr/>
        
                            {!isTablet && (
                                <p style={{fontSize: '12px', color: 'rgb(128, 128, 128)', fontWeight: 600, margin: '10px 0' }}>Log in takes less than a few seconds</p>
                            )}
                            
                            <GoogleBtn sidebar />

                            <div onClick={() => window.location = '/user_registration'} className='delivery_widget authPage grey_background'>
                                <div style={{height: '90%', margin: '5px 5px 5px -5px', color: '#000', padding: '3px', borderRadius: '50%', border: '1px solid #e6ecf0', boxSizing: 'border-box'}}>
                                    <MailIcon />
                                </div>

                                {!isTablet && (
                                    <span style={{fontWeight: 'bold'}}>
                                        Log In with Email
                                    </span>
                                )}
                                
                            </div>
                        </Fragment>
                    ) : (
                        <Fragment>
                            {!isMobile && (
                                <Fragment>
                                    <Button onClick={togglePostModal} variant="outlined" className="sidebar__tweet compose" fullWidth>
                                        {!isTablet ? 'Create Post' : <AddIcon />}
                                    </Button>
            
                                    <div style={{flex: 0.8, alignSelf: 'stretch'}}>
                                                
                                    </div>
            
                                    {/* Quick Profile Button */}
                                    <SidebarProfileWidget sidebarMobile={false} />
            
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </Fragment>
            )}

        </div>
    )
}

Sidebar.propTypes = {
    auth: PropTypes.object.isRequired, // Object prop representing the authentication data for the user
    nav: PropTypes.object.isRequired, // Prop: Object representing navigation state
    setPage: PropTypes.func.isRequired, // Function prop to set the current page
    togglePostModal: PropTypes.func.isRequired, // Function prop to toggle the post modal
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth,
    nav: state.nav
})

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setPage, 
    togglePostModal
})(Sidebar);
